import React from "react";

// Provides a way to show the "Include" checkbox for a zone in the RecEventZoneInfo component.
export const RecEventZoneCheckboxHostContext = React.createContext<HTMLElement | null>(null);
